import { Box, Button, Flex, HStack, IconButton, Image, Link } from "@chakra-ui/react";
import { useTranslation, withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FaGlobe } from "react-icons/fa";
import MobileNavbar from "../../public/Layout/mobileNavbar";
import { brandPalette } from "../../../constants/brandPalette";

const Navbar = ({ color, register, t, type }) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const routes = [
    { label: t("components.home_navbar.contact_us"), link: "#callCenter" },
    { label: t("components.home_navbar.teachers"), link: "#teachers" },
    { label: t("components.home_navbar.home"), link: "/" },
  ];

  return (
    <Box
      position="fixed"
      zIndex="100"
      top="0"
      id="navbar"
      color={color}
      py="16px"
      bg={brandPalette.cream}
      w="100%"
    >
      <HStack
        alignItems="center"
        p="0 20px"
        w="100%"
        justifyContent={{
          base: register ? "space-between" : "center",
          lg: "space-between",
        }}
        textTransform={"capitalize"}
        h="60px"
        maxW="1200px"
        mx="auto"
      >
        <Flex
          display={{ base: "none", lg: "flex" }}
          visibility={register ? "visible" : "hidden"}
          flexDir="row"
          w="100%"
          gap={6}
          alignItems="center"
        >
          <Button
            onClick={() => navigate("/login")}
            bg={brandPalette.secondary}
            color={brandPalette.cream}
            _hover={{
              bg: brandPalette.primary,
              transform: "translateY(-2px)",
              boxShadow: "0 12px 28px rgba(91, 13, 22, 0.25)",
            }}
            _active={{ transform: "translateY(0)" }}
            transition="all 0.3s ease"
            borderRadius="full"
            px={6}
            py={3}
            fontWeight="700"
            fontSize="16px"
            fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
            boxShadow="0 6px 18px rgba(91, 13, 22, 0.16)"
          >
            {t("login") || "تسجيل دخول"}
          </Button>

          <IconButton
            icon={<FaGlobe />}
            borderColor={brandPalette.primary}
            color={brandPalette.primary}
            variant="outline"
            borderWidth="2px"
            _hover={{
              bg: brandPalette.cream,
              borderColor: brandPalette.secondary,
              transform: "translateY(-2px)",
              boxShadow: "0 10px 24px rgba(91, 13, 22, 0.16)",
            }}
            _active={{ transform: "translateY(0)" }}
            transition="all 0.3s ease"
            borderRadius="full"
            size="md"
            onClick={() => {
              const lang = localStorage.getItem("lang");

              if (lang === "ar") {
                localStorage.setItem("lang", "en");
                i18n.changeLanguage("en");
              } else {
                localStorage.setItem("lang", "ar");
                i18n.changeLanguage("ar");
              }
            }}
          />

          <HStack spacing={8}>
            {routes?.map((elem, index) => {
              return (
                <Link
                  key={index}
                  href={elem.link}
                  color={brandPalette.secondary}
                  fontWeight="600"
                  fontSize="16px"
                  _hover={{
                    color: brandPalette.primary,
                    transform: "translateY(-2px)",
                  }}
                  transition="all 0.3s ease"
                  fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                >
                  {elem?.label}
                </Link>
              );
            })}
          </HStack>
        </Flex>

        {register ? (
          <Box display={{ base: "block", lg: "none" }}>
            <MobileNavbar />
          </Box>
        ) : null}
        <Box
          cursor="pointer"
          onClick={() => navigate("/")}
          _hover={{ transform: "scale(1.05)" }}
          transition="all 0.3s ease"
        >
          <Image
            src={require("../../../assets/logo.png")}
            w="180px"
            id="logo"
            h="auto"
            mx="auto"
          />
        </Box>
      </HStack>
    </Box>
  );
};

export default withTranslation()(Navbar);
